/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsPackingLineVo } from './GoodsPackingLineVo';
import {
    GoodsPackingLineVoFromJSON,
    GoodsPackingLineVoFromJSONTyped,
    GoodsPackingLineVoToJSON,
    GoodsPackingLineVoToJSONTyped,
} from './GoodsPackingLineVo';

/**
 * 
 * @export
 * @interface PackingItemVo
 */
export interface PackingItemVo {
    /**
     * 类型：0 箱子 1 托盘
     * @type {number}
     * @memberof PackingItemVo
     */
    type?: number;
    /**
     * 运费测算汇总中，箱子当托盘仍以{@code type=1} 返回；该字段用于区分真实托盘与箱子当托。
     * 是否箱子当托：0 否（普通箱子或真实托盘），1 是；仅 type=1 时有区分意义
     * @type {number}
     * @memberof PackingItemVo
     */
    boxAsPallet?: number;
    /**
     * id（type=0: boxId；type=1: palletId）
     * @type {number}
     * @memberof PackingItemVo
     */
    id?: number;
    /**
     * 唛头号 markNo
     * @type {string}
     * @memberof PackingItemVo
     */
    markNo?: string;
    /**
     * 物料 id（仅箱子；托盘为空）
     * @type {number}
     * @memberof PackingItemVo
     */
    materialId?: number;
    /**
     * 物料展示名（仅箱子）
     * @type {string}
     * @memberof PackingItemVo
     */
    materialDisplayName?: string;
    /**
     * 箱子为所选物料收费金额；托盘为托盘内箱材费合计（韩元）；自定义箱为 0，未匹配到有效包装服务时为空
     * @type {number}
     * @memberof PackingItemVo
     */
    materialAmount?: number;
    /**
     * 重量 kg
     * @type {number}
     * @memberof PackingItemVo
     */
    wtKg?: number;
    /**
     * CBM
     * @type {number}
     * @memberof PackingItemVo
     */
    cbm?: number;
    /**
     * 长 cm
     * @type {number}
     * @memberof PackingItemVo
     */
    length?: number;
    /**
     * 宽 cm
     * @type {number}
     * @memberof PackingItemVo
     */
    width?: number;
    /**
     * 高 cm
     * @type {number}
     * @memberof PackingItemVo
     */
    height?: number;
    /**
     * 是否单独保管 0不单独保管 1单独保管
     * @type {number}
     * @memberof PackingItemVo
     */
    separateStore?: number;
    /**
     * 已装托时：托盘 id（仅 type=箱子；未装托为 null）
     * @type {number}
     * @memberof PackingItemVo
     */
    palletId?: number;
    /**
     * 已装托时：托盘唛头号（仅 type=箱子；未装托为 null）
     * @type {string}
     * @memberof PackingItemVo
     */
    palletMarkNo?: string;
    /**
     * 是否包含入库检查有误商品：0 否，1 是
     * @type {number}
     * @memberof PackingItemVo
     */
    containsErrorGoods?: number;
    /**
     * 合包商品行（仅箱子）
     * @type {Array<GoodsPackingLineVo>}
     * @memberof PackingItemVo
     */
    lines?: Array<GoodsPackingLineVo>;
}

/**
 * Check if a given object implements the PackingItemVo interface.
 */
export function instanceOfPackingItemVo(value: object): value is PackingItemVo {
    return true;
}

export function PackingItemVoFromJSON(json: any): PackingItemVo {
    return PackingItemVoFromJSONTyped(json, false);
}

export function PackingItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PackingItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'boxAsPallet': json['boxAsPallet'] == null ? undefined : json['boxAsPallet'],
        'id': json['id'] == null ? undefined : json['id'],
        'markNo': json['markNo'] == null ? undefined : json['markNo'],
        'materialId': json['materialId'] == null ? undefined : json['materialId'],
        'materialDisplayName': json['materialDisplayName'] == null ? undefined : json['materialDisplayName'],
        'materialAmount': json['materialAmount'] == null ? undefined : json['materialAmount'],
        'wtKg': json['wtKg'] == null ? undefined : json['wtKg'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'separateStore': json['separateStore'] == null ? undefined : json['separateStore'],
        'palletId': json['palletId'] == null ? undefined : json['palletId'],
        'palletMarkNo': json['palletMarkNo'] == null ? undefined : json['palletMarkNo'],
        'containsErrorGoods': json['containsErrorGoods'] == null ? undefined : json['containsErrorGoods'],
        'lines': json['lines'] == null ? undefined : ((json['lines'] as Array<any>).map(GoodsPackingLineVoFromJSON)),
    };
}

export function PackingItemVoToJSON(json: any): PackingItemVo {
    return PackingItemVoToJSONTyped(json, false);
}

export function PackingItemVoToJSONTyped(value?: PackingItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'boxAsPallet': value['boxAsPallet'],
        'id': value['id'],
        'markNo': value['markNo'],
        'materialId': value['materialId'],
        'materialDisplayName': value['materialDisplayName'],
        'materialAmount': value['materialAmount'],
        'wtKg': value['wtKg'],
        'cbm': value['cbm'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'separateStore': value['separateStore'],
        'palletId': value['palletId'],
        'palletMarkNo': value['palletMarkNo'],
        'containsErrorGoods': value['containsErrorGoods'],
        'lines': value['lines'] == null ? undefined : ((value['lines'] as Array<any>).map(GoodsPackingLineVoToJSON)),
    };
}

